import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import type {
  SupplierBlendSave,
  SupplierManagedAllocationsUpdate,
} from '@ps/survey-utils';

import {
  ManageSupplierActions,
  OfferPriceToChildren,
} from './manage-supplier.actions';

@Injectable({ providedIn: 'root' })
export class ManageSupplierActionsFacade {
  private readonly _store = inject(Store);

  public load(surveyId: number, isChild: boolean): void {
    this._store.dispatch(ManageSupplierActions.load({ surveyId, isChild }));
  }

  public updateManagedAllocations(
    surveyId: number,
    update: SupplierManagedAllocationsUpdate,
  ): void {
    this._store.dispatch(
      ManageSupplierActions.updateManagedAllocations({ surveyId, update }),
    );
  }

  // The same PUT, then the global override CPI to the project's other children.
  public updateManagedAllocationsToChildren(
    surveyId: number,
    update: SupplierManagedAllocationsUpdate,
    offerPriceToChildren: OfferPriceToChildren,
  ): void {
    this._store.dispatch(
      ManageSupplierActions.updateManagedAllocations({
        surveyId,
        update,
        offerPriceToChildren,
      }),
    );
  }

  public saveBlend(data: SupplierBlendSave): void {
    this._store.dispatch(ManageSupplierActions.saveBlend({ data }));
  }

  public reset(): void {
    this._store.dispatch(ManageSupplierActions.reset());
  }
}
